<template>
    <div :class="classes">
        <el-row class="p-list" :gutter="30">
            <el-col
                :xl="4"
                :lg="6"
                :md="8"
                :sm="12"
                class="p-list-item"
                v-for="(item, idx) in list"
                :key="idx">
                <div class="p-card"
                    @mouseenter="isBatch && (currentHoverCard = idx)"
                    @mouseleave="isBatch && (currentHoverCard = '')">
                    <div class="p-image-wrap" @click="cardCheckClick(item)">
                        <u-flex-box scale="3/4">
                            <el-image
                                :ref="`picture-${item.id}`"
                                :preview-src-list="[item.url]"
                                :src="`${item.thumbPicUrl}?x-oss-process=image/resize,m_lfit,h_400,w_400`"></el-image>
                        </u-flex-box>
                        <transition name="el-fade-in-linear">
                            <div
                                :class="{ 'p-card-checked': item.checked }"
                                class="p-check-wrap"
                                v-if="idx === currentHoverCard || item.checked">
                                <i class="el-icon-success"></i>
                                <div class="p-check-operation" @click.prevent.stop >
                                    <el-button size="mini" @click="viewDetail(item)" v-if="currentHoverCard === idx">
                                        <i class="el-icon-document"></i>
                                        详情
                                    </el-button>
                                    <el-button size="mini" @click="viewBigImage(item)" v-if="currentHoverCard === idx">
                                        <i class="el-icon-zoom-in"></i>
                                        大图
                                    </el-button>
                                    <div class="doc_btn" v-if="item.checkSteps==0&&item.checked&&currentHoverCard === idx?(item.is_check_recommend?true:false):item.is_recommend_js" :class="item.is_recommend_js?'doc_color':''" @click="recommend(idx,item)">
                                        推荐
                                    </div>
                                    
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="p-desc-wrap">
                        <p class="p-title">
                            <span class="p-strong">
                                {{ `${state[item.checkStatus]}${+item.checkSteps + 1}/${Object.keys(step).length}` }}
                            </span>
                            {{ item.midIdName }}
                        </p>
                        <div class="w-user-info-wrap">
                            <div class="w-avatar">
                                <img :src="item.avatar">
                            </div>
                            <span class="w-name" :title="item.username">
                                {{ item.username }}
                            </span>
                            <span class="w-time">{{ item.createdAt }}</span>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <slot />

        <!-- 审核对话框 -->
        <el-dialog
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            center
            class="p-examine-dialog"
            :title="dialogTitle"
            :visible="showExamineDialog"
            width="800px"
            @closed="examineForm = {}"
            :before-close="() => showExamineDialog = false">

            <div class="w-pic-list">
                <ul>
                    <li v-for="(item, idx) in Object.values(checkeds)" :key="idx">
                        <div
                            class="p-image-wrap"
                            :class="{ 'w-image-checked': currentDialogClickCard.photoId === item.photoId }"
                            @click="dialogCardCheckClick(item)"
                            @mouseenter="currentDialogHoverCard = idx"
                            @mouseleave="currentDialogHoverCard = ''"
                        >
                            <u-flex-box scale="3/4">
                                <el-image :ref="`picture-${item.id}`" :preview-src-list="[item.url]"  :src="`${item.thumbPicUrl}?x-oss-process=image/resize,m_lfit,h_400,w_400`"></el-image>
                            </u-flex-box>
                            <span v-if="!item.isDataFull" class="w-data-defect-tag"></span>
                            <transition name="el-fade-in-linear">
                                <div
                                    v-if="currentDialogHoverCard === idx"
                                    class="p-check-wrap"
                                    >
                                    <div class="w-user-info-wrap">
                                        <span class="w-state">{{ `${+item.checkSteps + 1}/${Object.keys(step).length}` }}</span>
                                        <div class="w-avatar">
                                            <img :src="item.avatar">
                                        </div>
                                        <span class="w-name" :title="item.username">
                                            {{ item.username }}
                                        </span>
                                    </div>
                                    <div class="p-check-operation" @click.stop>
                                        <el-button size="mini" @click="viewDetail(item, false)">
                                            <i class="el-icon-document"></i>
                                            详情
                                        </el-button>
                                        <el-button size="mini" @click="viewDialogBigImage(item)">
                                            <i class="el-icon-zoom-in"></i>
                                            大图
                                        </el-button>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="w-form-wrap">
                <!-- 审核第一步 -->
                <el-form
                    label-width="110px"
                    v-if="dialogType === 'examine' && +currentDialogClickCard.checkSteps === 0">

                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            素材名称
                        </template>
                        <el-input
                            v-model="currentDialogClickCard.midName"
                            show-word-limit
                            maxlength="20"
                            placeholder="*请输入素材名称">
                        </el-input>
                        <!-- 素材名称 -->
                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'midName'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[素材名称]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('midName')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'midName'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            素材类型
                        </template>
                        <el-select @change="styleChange" v-model="currentDialogClickCard.style" placeholder="请选择素材类型">
                            <el-option :key="idx" v-for="(item, idx) in styles" :label="item.name" :value="item.type">
                            </el-option>
                        </el-select>
                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'style'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[素材类型]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('style')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'style'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item label="综合评级">
                        <div class="p-level-wrap">
                            <template v-if="grades.length">
                                <div class="p-level-item"
                                    v-for="(level, idx) in grades"
                                    :key="idx"
                                    :class="{ 'p-level-item-active': level.level === currentDialogClickCard.level }"
                                    @click="levelChange(level.level)">
                                    <img :src="level.samplePics">
                                    <div class="p-level-content">
                                        <h3>{{ level.level }}</h3>
                                        <div class="p-level-desc">
                                            {{ level.levelStandard }}
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <span v-else class="p-tips">请选择素材类型</span>
                        </div>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'level'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[综合评级]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('level')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" v-show="grades.length" slot="reference" @click="currentPopover = 'level'" class="p-cover-btn w-cover-note-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <!-- 是否推荐 -->
                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            是否推荐
                        </template>
                        <el-select v-model="currentDialogClickCard.is_recommend_js" placeholder="请选择素材格式" @change="change_recommend(currentDialogClickCard)">
                            <el-option v-for="(item,index) in recommended_list" :key="index" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'is_recommend_js'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[是否推荐]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('is_recommend_js')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'is_recommend_js'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            标签
                        </template>
                        <p class="p-tip">功能标签（请至少选择1个）</p>
                        <div class="p-tag-wrap">
                            <el-cascader
                                v-model="currentDialogClickCard.tags"
                                :show-all-levels="false"
                                ref="tag"
                                :options="tags"
                                :props="{ multiple: true }"
                                clearable>
                            </el-cascader>

                            <el-popover
                                popper-class="w-examine-cover-popover"
                                trigger="manual"
                                :value="currentPopover === 'tags'"
                                @input="popoverChange"
                                placement="bottom-start"
                                width="300">
                                <div class="w-content">
                                    是否将当前
                                    <span class="w-strong">[功能标签]</span>
                                    的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                                </div>
                                <div class="w-btn-wrap">
                                    <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                    <el-button size="mini" type="primary" @click="coverClick('tags')">确定覆盖</el-button>
                                </div>
                                <el-button type="text" slot="reference" @click="currentPopover = 'tags'" class="p-cover-btn">一键覆盖</el-button>
                            </el-popover>
                        </div>
                        <p class="p-tip">
                            查询标签（请添加素材元素相关的标签，至少1个）</p>
                        <el-popover
                            placement="bottom"
                            title="提示"
                            width="200"
                            trigger="manual"
                            v-model="showTagAddPopover">
                            <div class="p-search-tag-add-popover">
                                <p>是否添加{{ newTag }}标签?</p>
                                <br>
                                <div style="text-align: center">
                                    <el-button size="small" @click="cancelTagAdd">取消</el-button>
                                    <el-button size="small" type="primary" @click="addTagSearchId">确定添加</el-button>
                                </div>
                            </div>
                            <div slot="reference" style="display: inline-block;">
                                <el-select
                                    @focus="showTagAddPopover = false"
                                    ref="searchTag"
                                    no-data-text="无数据,请选择素材类型"
                                    @change="currencyTagChange"
                                    filterable
                                    allow-create
                                    multiple
                                    default-first-option
                                    v-model="currentDialogClickCard.currencyTag"
                                    placeholder="请选择查询标签">
                                    <el-option v-for="item in currencyTags" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-popover>
                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'currencyTag'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[查询标签]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('currencyTag')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'currencyTag'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            素材格式
                        </template>
                        <el-select v-model="currentDialogClickCard.format" placeholder="请选择素材格式">
                            <el-option v-for="format in formats" :key="format" :label="format" :value="format">
                            </el-option>
                        </el-select>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'format'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[素材格式]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('format')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'format'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item label="是否与IP相关">
                        <el-radio-group v-model="currentDialogClickCard.isRelationIp" size="medium">
                            <el-radio-button :label="0" >无关</el-radio-button>
                            <el-radio-button :label="1">相关</el-radio-button>
                        </el-radio-group>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'isRelationIp'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[是否与IP相关]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('isRelationIp')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'isRelationIp'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>

                        <el-select style="margin-top: 10px; display: block" v-model="currentDialogClickCard.ip" placeholder="请选择素材相关的IP" v-if="+currentDialogClickCard.isRelationIp === 1">
                            <el-option v-for="(item, idx) in ipList" :key="idx" :label="item.name" :value="item.ipId">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="审核备注">
                        <el-input
                            v-model="currentDialogClickCard.remarks"
                            show-word-limit
                            maxlength="100"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入审核备注">
                        </el-input>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'remarks'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[审核备注]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('remarks')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'remarks'" class="p-cover-btn w-cover-note-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>
                </el-form>

                <!-- 审核二三步 -->
                <el-form
                    label-width="110px"
                    v-else-if="dialogType === 'examine' && (+currentDialogClickCard.checkSteps === 1 || +currentDialogClickCard.checkSteps === 2)">
                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            结算方式
                        </template>
                        <el-radio-group v-model="currentDialogClickCard.dealType">
                            <el-radio-button :key="type" :label="type" v-for="type in Object.keys(dealType)">{{ dealType[type] }}</el-radio-button>
                        </el-radio-group>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'dealType'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[结算方式]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('dealType')">确定覆盖</el-button>
                            </div>
                            <el-button v-show="currentDialogClickCard.edit && +currentDialogClickCard.checkSteps === 1" type="text" slot="reference" @click="currentPopover = 'dealType'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item v-if="+currentDialogClickCard.dealType === 1">
                        <template #label>
                            <span class="w-required-tag">*</span>
                            验收价格
                        </template>
                        <el-input-number
                            v-if="currentDialogClickCard.edit"
                            :min="0"
                            :precision="2"
                            placeholder="请选择验收价格，单位（元）"
                            v-model="currentDialogClickCard.acceptancePrice">
                        </el-input-number>
                        <div v-else>
                            {{ currentDialogClickCard.acceptancePrice }}
                            <el-button size="mini" @click="currentDialogClickCard.edit = true">修改</el-button>
                        </div>
                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'acceptancePrice'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[验收价格]</span>
                                是否将当前[验收价格]的配置信息，一键覆盖到所有选中且结算方式为
                                <span class="w-strong">[买断]</span>
                                的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('acceptancePrice')">确定覆盖</el-button>
                            </div>
                            <el-button v-show="currentDialogClickCard.edit && +currentDialogClickCard.checkSteps === 1" type="text" slot="reference" @click="currentPopover = 'acceptancePrice'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item v-if="+currentDialogClickCard.dealType === 2">
                        <template #label>
                            <span class="w-required-tag">*</span>
                            分成比例
                        </template>
                        <el-input-number
                            v-if="currentDialogClickCard.edit"
                            :min="0"
                            :max="100"
                            :precision="0"
                            placeholder="请输入分成比例，单位（%）；普通个人作品默认30%"
                            v-model="currentDialogClickCard.userSplitRate">
                        </el-input-number>
                        <div v-else class="">
                            {{ currentDialogClickCard.userSplitRate }}
                            <el-button size="mini" @click="currentDialogClickCard.edit = true">修改</el-button>
                        </div>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'userSplitRate'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                <span class="w-strong">[验收价格]</span>
                                是否将当前[验收价格]的配置信息，一键覆盖到所有选中且结算方式为
                                <span class="w-strong">[分成]</span>
                                的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('userSplitRate')">确定覆盖</el-button>
                            </div>
                            <el-button v-show="currentDialogClickCard.edit && +currentDialogClickCard.checkSteps === 1" type="text" slot="reference" @click="currentPopover = 'userSplitRate'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>
                            奖励金
                        </template>
                        <el-input-number
                            v-if="currentDialogClickCard.edit"
                            :min="0"
                            :max="1000"
                            placeholder="请输入奖励金，单位（元）；填写0视为没有奖励金"
                            :precision="2"
                            v-model="currentDialogClickCard.rewardMoney">
                        </el-input-number>
                        <div v-else class="">
                            {{ currentDialogClickCard.rewardMoney }}
                            <el-button size="mini" @click="currentDialogClickCard.edit = true">修改</el-button>
                        </div>
                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'rewardMoney'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[奖励金]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('rewardMoney')">确定覆盖</el-button>
                            </div>
                            <el-button v-show="currentDialogClickCard.edit && +currentDialogClickCard.checkSteps === 1" type="text" slot="reference" @click="currentPopover = 'rewardMoney'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>

                    <!-- 第三步 是否推荐 -->
                    <el-form-item v-if="+currentDialogClickCard.checkSteps === 2">
                        <template #label>
                            <span class="w-required-tag">*</span>
                            是否推荐
                        </template>
                        <el-select v-if="currentDialogClickCard.edit" v-model="currentDialogClickCard.isRecommend" placeholder="请选择">
                            <el-option
                            v-for="item in recommended_list_t3"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <div v-else class="">
                            {{ currentDialogClickCard.isRecommend=='1'?'是':'否' }}
                            <el-button size="mini" @click="currentDialogClickCard.edit = true">修改</el-button>
                        </div>
                    </el-form-item>
                </el-form>

                <!-- 驳回 -->
                <el-form label-width="110px" v-else-if="dialogType === 'reject'">
                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>驳回理由
                        </template>
                        <el-radio-group v-model="currentDialogClickCard.reason">
                            <el-radio
                                :key="idx"
                                v-for="(rejectReason, idx) in rejectReasonList"
                                :label="rejectReason.content">
                                {{ rejectReason.content }}
                            </el-radio>
                            <el-radio label="其他">
                                其他理由（请在详细说明中填写）
                            </el-radio>
                        </el-radio-group>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'reason'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[驳回理由]</span>
                                的配置信息，一键覆盖到所有选中的待审（{{ `${+currentDialogClickCard.checkSteps + 1}/${Object.keys(step).length}` }}）作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('reason')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'reason'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>
                    <el-form-item>
                        <template #label>
                            驳回说明
                        </template>
                        <el-input
                            class="p-comment"
                            v-model="currentDialogClickCard.comment"
                            show-word-limit
                            maxlength="100"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入内容">
                        </el-input>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'comment'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[驳回说明]</span>
                                的配置信息，一键覆盖到所有选中的待审作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('comment')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'comment'" class="p-cover-btn w-cover-note-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>
                </el-form>

                <!-- 回退 -->
                <el-form label-width="110px" v-else-if="dialogType === 'back'">
                    <el-form-item>
                        <template #label>
                            <span class="w-required-tag">*</span>回退位置
                        </template>
                        <el-select v-model="currentDialogClickCard.back" placeholder="请选择回退位置">
                            <el-option v-for="item in backList(currentDialogClickCard.checkSteps)" :key="item.key" :label="item.value" :value="item.key">
                            </el-option>
                        </el-select>

                        <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'back'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[回退位置]</span>
                                一键覆盖到所有选中且可回退至该步的作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('back')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'back'" class="p-cover-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>
                    <el-form-item label="审核备注">
                        <template #label>
                            <span class="w-required-tag">*</span>审核备注
                        </template>
                        <el-input
                            v-model="currentDialogClickCard.remarks"
                            show-word-limit
                            maxlength="100"
                            type="textarea"
                            :rows="3"
                            placeholder="请输入审核备注">
                        </el-input>

                         <el-popover
                            popper-class="w-examine-cover-popover"
                            trigger="manual"
                            :value="currentPopover === 'remarks'"
                            @input="popoverChange"
                            placement="bottom-start"
                            width="300">
                            <div class="w-content">
                                是否将当前
                                <span class="w-strong">[审核备注]</span>
                                一键覆盖到所有选中且可回退至该步的作品上？
                            </div>
                            <div class="w-btn-wrap">
                                <el-button size="mini" @click="currentPopover = ''">取消</el-button>
                                <el-button size="mini" type="primary" @click="coverClick('remarks')">确定覆盖</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="currentPopover = 'remarks'" class="p-cover-btn w-cover-note-btn">一键覆盖</el-button>
                        </el-popover>
                    </el-form-item>
                </el-form>

                <div class="w-remove-examine">
                    <el-button @click="removeClick(currentDialogClickCard)" v-if="Object.keys(checkeds).length">稍后再审</el-button>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <span class="p-checked-count">已选择{{ Object.keys(checkeds).length }}个</span>
                <el-button @click="showExamineDialog = false">
                    关 闭
                    <span v-if="dialogCloseCountDown">({{ dialogCloseCountDown }})</span>
                </el-button>
                <el-button v-if="dialogType === 'examine'" :loading="Boolean(examining)" type="primary" @click="submitForm">
                    <span v-if="examining">批量审核中...</span>
                    <span v-else>确认审核通过</span>
                    <span v-if="examining">({{ `${examining}/${examiningCount}` }})</span>
                </el-button>
                <el-button v-if="dialogType === 'back'" :loading="Boolean(examining)" type="warning" @click="submitForm">
                    <span v-if="examining">批量回退中...</span>
                    <span v-else>确认回退</span>
                    <span v-if="examining">({{ `${examining}/${examiningCount}` }})</span>
                </el-button>
                <el-button v-if="dialogType === 'reject'" :loading="Boolean(examining)" type="danger" @click="submitForm">
                    <span v-if="examining">批量驳回中...</span>
                    <span v-else>确认审核驳回</span>
                    <span v-if="examining">({{ `${examining}/${examiningCount}` }})</span>
                </el-button>
            </span>
        </el-dialog>

        <!-- submit error tips -->
        <el-dialog
            class="p-examine-dialog w-error-dialog"
            :title="`本次共审核通过${Object.values(errorsTip).length}个作品，部分审核提交失败，请重新尝试`"
            :visible.sync="showErrorDialog"
            width="600px"
            center
            :before-close="() => showErrorDialog = false">
            <el-form >
                <el-form-item v-for="(item, idx) in Object.values(errorsTip)" :key="idx">
                    <div class="w-pic-list">
                        <div
                            class="p-image-wrap"
                            @mouseenter="currentDialogHoverCard = idx"
                            @mouseleave="currentDialogHoverCard = ''"
                        >
                            <u-flex-box scale="3/4">
                                <el-image :ref="`picture-${item.id}`" :preview-src-list="[item.url]"  :src="`${item.thumbPicUrl}?x-oss-process=image/resize,m_lfit,h_400,w_400`"></el-image>
                            </u-flex-box>
                            <span v-if="!item.isDataFull" class="w-data-defect-tag"></span>
                            <transition name="el-fade-in-linear">
                                <div
                                    v-if="currentDialogHoverCard === idx"
                                    class="p-check-wrap"
                                    >
                                    <div class="w-user-info-wrap">
                                        <span class="w-state">{{ `${+item.checkSteps + 1}/${Object.keys(step).length}` }}</span>
                                        <div class="w-avatar">
                                            <img :src="item.avatar">
                                        </div>
                                        <span class="w-name" :title="item.username">
                                            {{ item.username }}
                                        </span>
                                    </div>
                                    <div class="p-check-operation" @click.stop>
                                        <el-button size="mini" @click="viewDetail(item, false)">
                                            <i class="el-icon-document"></i>
                                            详情
                                        </el-button>
                                        <el-button size="mini" @click="viewDialogBigImage(item)">
                                            <i class="el-icon-zoom-in"></i>
                                            大图
                                        </el-button>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>

                    <span>{{ item.errMsg }}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="errorTipsDialogCancelClick">取 消</el-button>
                <el-button type="primary" @click="errorTipsDialogOkClick">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { forEachTree } from '@/common/utils' 
import camelcase from 'camelcase-keys-deep';
const prefix = "w-batch-examine";

export default {
    props: {
        data: {
            type: Array,
            default: () => []
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            prefix,
            list: [],

            currentItem: {},
            currentHoverCard: '',
            // 是否启动多选模式
            isBatch: true,
            // 已勾选列表
            checkeds: {},

            // 是否显示审核对话框
            showExamineDialog: false,
            // 审核表单对象
            examineForm: {},
            // 素材列表
            styles: [],
            // 功能标签列表
            tags: [],
            // 查询标签列表
            currencyTags: [],
            // 素材格式列表
            formats: [],

            // 审核中
            examining: 0,

            // 是否显示驳回对话框
            showRejectDialog: false,
            // 是否显示回退对话框
            showBackDialog: false,

            // 驳回理由列表
            rejectReasonList: [],
            rejectReason: '',

            rejectForm: {},
            edit: true,
            dealType: { 1: '买断', 2: '分成' },
            state: {"0": "待审核", "1": "审核通过", "-1": "审核驳回", "-2": "失效或撤回", "-3": "回退"},
            step: {
                0: '视觉审核' ,
                1: '价格确认' ,
                2: '价格审批'
            },

            currentDialogHoverCard: '',
            currentDialogClickCard: {},
            dialogCloseCountDown: 0,

            // 对话框类型
            dialogType: '',

            // 覆盖popover名称
            currentPopover: '',

            showErrorDialog: false,
            errorsTip: {},

            dialogTitle: '',
            examiningCount: 0,
            grades: [],

            showTagAddPopover: false,
            newTag: '',
            recommended_list:[
                {label:'否',value:false},
                {label:'是',value:true}
            ],
            recommended_list_t3:[
                {label:'否',value:'0'},
                {label:'是',value:'1'}
            ]
        };
    },
    methods: {
        change_recommend(val){
            console.log('是否推荐下拉框选择')
            //是否推荐
            // this.list.forEach((val)=>{
            //     if(val.id == item.id){
            //         val.is_recommend_js = item.is_recommend_js
            //     }
            // })
        },
        recommend(index,val){ 
            console.log(val,'val')
            let list = JSON.parse(JSON.stringify(this.list))
            if(list[index].checked){
                list[index].is_recommend_js = !list[index].is_recommend_js
            }else{
                this.$message.warning('需要先勾选为批量审核数据，才能勾选推荐')
            }
            this.list = list

            Object.values(this.checkeds).forEach((itme)=>{
                if(itme.id == val.id){
                    itme.is_recommend_js = !itme.is_recommend_js
                }
            })
            
            console.log(Object.values(this.checkeds),'点击推荐按钮')            
        
        },
        init() {
            this.getMidTypes()
            this.getTagFuncId()
            this.getMidFormats()
            this.reviewreason()
            this.getGrades()
            this.photoworkIpList()
        },
        async photoworkIpList() {
            let data = await this.api.photoworkIpList()
            this.ipList = data
        },
        async getGrades() {
            let data = await this.api.getProgressPhotoWorklist();
            if(JSON.stringify(data) === '{}') {
                this.$message.error('请设置摄影定价配置')
            }else {
                let config = JSON.parse(data.priceConfig || '{}')
                let newConfig = {}

                Object.keys(config).forEach(key => {
                    newConfig[key] = {}
                    Object.keys(config[key]).forEach(level => {
                        newConfig[key][level] = camelcase(config[key][level])
                    })
                })

                this.priceConfig = newConfig
            }
        },
        levelChange(level) {
            this.$set(this.currentDialogClickCard, 'level', level)
        },
        errorTipsDialogCancelClick() {
            this.showErrorDialog = false
            this.allCheckClick(false)
        },
        errorTipsDialogOkClick() {
            this.showErrorDialog = false
            this.showExamineDialog = true
        },
        popoverChange(val) {
            if(!val) {
                this.currentPopover = ''
            }
        },
        coverClick(field) {
            console.log(field,'field')
            if(field === 'tags') {
                Object.values(this.checkeds)
                    .forEach(item => item['formTag'] = this.$refs.tag.getCheckedNodes(true).map(item => item.value))
            }

            let val = this.currentDialogClickCard[field]
            let { style } = this.currentDialogClickCard
            console.log(Object.values(this.checkeds),'Object.values(this.checkeds)')
            Object.values(this.checkeds).forEach(item => {
                if(field === 'back') {
                    if(val < item.checkSteps) {
                        this.$set(item, field, val)
                    }
                }else if(field === 'style') {
                    if(val !== item.style) {
                        this.$set(item, field, val)
                        this.$set(item, 'currencyTag', [])
                    }
                }else if(field === 'currencyTag') {
                    if(style === item.style) {
                        this.$set(item, field, val)
                    }
                } else if(this.dialogType === 'examine') {
                    if(+item.checkSteps !== 2) {
                        this.$set(item, field, val)
                    }
                } else {
                    this.$set(item, field, val)
                }

                if (field === 'isRelationIp') {
                    this.$set(item, 'ip', this.currentDialogClickCard.ip)
                }
            })
            this.setIsDataFull()
            this.currentPopover = ''

            this.$message.success('覆盖成功')
        },
        dialogCardCheckClick(item) {
            console.log(item,'dialogCardCheckClick')
            this.currentDialogClickCard = item || {}
            this.currentDialogClickCard.edit = false

            // //是否推荐
            // this.list.forEach((val)=>{
            //     if(val.id == this.currentDialogClickCard.id){
            //         this.currentDialogClickCard.is_recommend_js = val.is_recommend_js
            //     }
            // })

            this.getTagSearchId()
        },
        removeClick(item, showEmptyTips = true) {
            let photoId = item.photoId
            let currentIdx = Object.values(this.checkeds).findIndex(item => item.photoId === photoId)

            this.$delete(this.checkeds, photoId)

            if( currentIdx > (Object.values(this.checkeds).length - 1)) {
                item = Object.values(this.checkeds).slice(-1)[0]
            }else {
                item = Object.values(this.checkeds)[currentIdx]
            }
            this.dialogCardCheckClick(item)

            if(Object.values(this.checkeds).length === 0 && showEmptyTips) {
                this.$message.warning('无可操作的审核项目，对话框即将关闭')
                this.dialogCloseCountDown = 3

                if(this.dialogCloseCountDown) {
                    let timer = window.setInterval(() => {
                        this.dialogCloseCountDown --
                        if(this.dialogCloseCountDown === 0) {
                            clearInterval(timer)
                            this.showExamineDialog = false
                        }
                    }, 1000)
                }
                return
            }
        },
        // 默认选中
        defaultCheckedOne() {
            if(Object.values(this.checkeds).length) {
                let item = Object.values(this.checkeds)[0]

                this.dialogCardCheckClick(item)
            }
        },
        viewDetail(item, showOperation = true) {
            this.$emit('viewDetail', item, showOperation)
        },
        cardCheckClick(item) {
            console.log(item,'item')
            if(this.isBatch) {
                item.checked = !item.checked
            }
            item.is_check_recommend = !item.is_check_recommend
        },
        // 取消选择点击
        cancelClick() {
            this.list.forEach(item => (item.checked = false))
            this.isBatch = false
        },
        allCheckClick(is) {
            this.list.forEach(item => (item.checked = is))
            if(!is) {
                this.checkeds = {}
            }
        },
        viewDialogBigImage(item) {
            this.$refs[`picture-${item.id}`][1].showViewer = true
            this.currentDialogHoverCard = ''
        },
        viewBigImage(item) {
            this.$refs[`picture-${item.id}`][0].showViewer = true
        },
        async getMidTypes() {
            let data = await this.api.getMidTypes()
            this.styles = data.filter(item => Object.keys(this.priceConfig).includes(item.type))
        },
        styleChange(val) {
            this.$set(this.currentDialogClickCard, 'currencyTag', [])

            this.getTagSearchId()

            if(this.priceConfig[val]) {
                this.grades = Object.keys(this.priceConfig[val]).filter(key => key !== 'is_level').map(key => ({ level: key, ...this.priceConfig[val][key] }))

                if(this.grades.length) {
                    this.levelChange(this.grades[0].level)
                }
            }else {
                this.grades = []
                this.$message.warning('当前素材类型没有设置评级, 请到【内容-工具箱-业务流程管理】设置')
            }
        },
        async getTagFuncId() {
            let data = await this.api.getTagFuncId()
            this.tags = forEachTree(data, (item) => {
                item.value = item.id
                item.label = item.name
            })
        },
        async getTagSearchId() { 
            this.currencyTags = []

            if(this.currentDialogClickCard.style) {
                this.currencyTags = await this.api.getTagSearchId({
                    type: this.currentDialogClickCard.style,
                    material: 1
                })
            }
        },
        async getMidFormats() {
            this.formats = await this.api.getMidFormats()
        },
        async submitForm() {
            let checkedList = Object.values(this.checkeds)
            this.examiningCount = checkedList.length

            if(checkedList.filter(item => !item.isDataFull).length) {
                this.$message.error('存在未配置的审核信息，请补全后再提交')
            }else {
                for(let idx in JSON.parse(JSON.stringify(checkedList))) {
                    let item = checkedList[idx]

                    this.examining = +idx + 1

                    try {
                        // 待审
                        if(this.dialogType === 'examine') {
                            if(+item.checkSteps === 0) {
                                console.log(item,'请求')
                                await this.photoworkReviewcheck(item)
                            }else {
                                await this.photoworkReviewcheckTwoAndThree(item)
                            }
                        }else if(this.dialogType === 'back') {
                            await this.backReview(item)
                        }else if(this.dialogType === 'reject') {
                            await this.reviewCheck(item)
                        }

                        this.$delete(this.checkeds, item.photoId)
                    } catch(err) {
                        item = JSON.parse(JSON.stringify(item))
                        item.errMsg = err

                        this.errorsTip[item.photoId] = item
                    }
                }

                this.examining = 0
                this.showExamineDialog = false

                if(Object.values(this.errorsTip).length) {
                    this.showErrorDialog = true
                }else {
                    this.$message.success('批量操作成功')
                }

                this.$emit('operationSuccess')
            }
        },
        // 审核第一步
        async photoworkReviewcheck(item) { 
            let { style, currencyTag, format, remarks, id, photoId, formTag, midName, level, isRelationIp, ip ,is_recommend_js } = item

            await this.api.photoworkReviewcheck({
                midType: style,
                tagFuncId: formTag.join(','),
                tagSearchId: currencyTag.join(','),
                midFormat: format,
                remark: remarks,
                type: 8, // 固定写死
                checkStatus: 1, // 固定写死
                checkSteps: 1, // 固定写死
                id,
                photoId,
                midName,
                $showError: false,
                level,
                isRelationIp,
                ip,
                formats: JSON.stringify({
                    '素材名称': midName,
                    '素材类型': this.currentStyleName,
                    '综合评级': level,
                    '功能标签': this.currentTagNames,
                    '查询标签': this.currencyTagNames,
                    '素材格式': format,
                    '是否与IP相关': this.currentIpName,
                    '备注': remarks
                })
            })
            //摄影作品设置/取消设置推荐状态
            await this.api.admin_photowork_setRecommendStatus({
                photo_id:photoId,
                status:is_recommend_js?1:0
            })
        },
        // 审核二三步
        async photoworkReviewcheckTwoAndThree(item) {
            let { acceptancePrice = '', userSplitRate = '', rewardMoney = '', dealType, id, photoId, checkSteps,isRecommend } = item
            
            await this.api.photoworkReviewcheck({
                type: 8, // 固定写死
                checkStatus: 1, // 固定写死
                checkSteps: +checkSteps + 1, // 固定写死
                id,
                photoId,
                acceptancePrice,
                userSplitRate,
                rewardMoney,
                dealType,
                $showError: false,
                formats: JSON.stringify({
                    '结算方式': this.dealType[dealType],
                    [`${+dealType === 1 ? '验收价格' : '分成比例'}`]:
                        +dealType === 1 ? `￥${acceptancePrice}` :  `${userSplitRate}%`,
                    '奖励金': `￥${rewardMoney}`,
                })
            })

            //摄影作品设置/取消设置推荐状态
            await this.api.admin_photowork_setRecommendStatus({
                photo_id:photoId,
                status:isRecommend
            })

        },
        // 回退
        async backReview(item) {
            let { back, remarks: remark, photoId, id } = item

            await this.api.photoworkReviewcheck({
                backward: 1,
                type: 8,
                photoId,
                id,
                remark,
                check_status: -3,
                check_steps: back,
                $showError: false,
                formats: JSON.stringify({
                    '回退位置': this.currentBackName,
                    '审核备注': remark
                })
            })
        },
        // 驳回
        async reviewCheck(item) {
            let { reason, comment, photoId, id, checkSteps } = item

            await this.api.photoworkReviewcheck({
                type: 8, // 固定写死
                photoId,
                id,
                check_status: -1, // 固定写死
                check_steps: checkSteps,
                check_reason: reason,
                check_comment: comment,
                $showError: false,
                formats: JSON.stringify({
                    '驳回理由': reason,
                    '备注': comment
                })
            })
        },
        examineDialogClose() {
            this.showExamineDialog = false
        },
        setTitle() {
            switch (this.dialogType) {
                case 'examine':
                    this.dialogTitle = '请选择切换作品，确认审核通过信息'
                    break;
                case 'back':
                    this.dialogTitle = '请选择切换作品，确认审核回退信息'
                    break;
                case 'reject':
                    this.dialogTitle = '请选择切换作品，确认审核驳回信息'
                    break;
            }
        },
        // 审核点击
        async checkClick(type) {
            this.getMidTypes()
            this.errorsTip = {}
            this.dialogType = type

            this.setTitle()
            this.setIsDataFull()

            let msg = this.filterData()

            setTimeout(() => {
                if(Object.keys(this.checkeds).length) {
                    this.showExamineDialog = true
                    this.defaultCheckedOne()
                }else {
                    window.setTimeout(() => {
                        this.$message.error('请选择审核项')
                    }, 2000)
                }

                setTimeout(() => msg && this.$message.error(msg), 10)
            }, 0)
        },
        // 过滤已勾选无效的数据
        filterData() {
            let msg = ''
            let checkeds = []

            if (this.dialogType === 'back') {
                checkeds = Object.keys(this.checkeds).filter(key => +this.checkeds[key].checkSteps === 0)
                if(Object.keys(checkeds).length) {
                    msg = `已自动清除${checkeds.length}项步骤1/${Object.keys(this.step).length}的无效数据`
                }
            }

            if(checkeds.length) {
                this.list.forEach(item => {
                    if(checkeds.includes(item.photoId)) {
                        item.checked = false
                    }
                })
            }

            return msg
        },
        async reviewreason() {
            let data = await this.api.reviewreason({ limit: 100, type: 8 })
            this.rejectReasonList = data.data
        },
        cancelTagAdd() {
            let idx = this.currentDialogClickCard.currencyTag.indexOf(this.newTag)
            ~idx && this.currentDialogClickCard.currencyTag.splice(idx, 1)

            this.showTagAddPopover = false
        },
        async addTagSearchId() {
            let tags = this.currentDialogClickCard.currencyTag

            try {
                    await this.api.addTagSearchId({
                        name: this.newTag,
                        type: this.currentDialogClickCard.style,
                        material: 1
                    })
                    await this.getTagSearchId()

                    const idx = tags.indexOf(this.newTag)
                    const tag = this.currencyTags.find(item => item.name === this.newTag)

                    if(~idx && tag) {
                        tags.splice(idx, 1, tag.id)
                        this.currentDialogClickCard.currencyTag = tags

                        this.showTagAddPopover = false
                        this.$message.success('标签新增成功')
                    }else {
                        this.$message.error(`新增查询标签失败! 标签列表不存在${this.newTag}`)
                    }
                } catch (error) {
                    this.$message.error(`新增查询标签失败! ${error}`)
                }
        },
        // currencyTags 列表id不能是字符串，否则新增tag会有问题。
        async currencyTagChange(tags) {
            const newTag = tags.find(tagId => !this.currencyTags.find(item => item.id === tagId))
            this.newTag = newTag

            // 新增标签
            if(newTag) {
                this.showTagAddPopover = true
                this.$refs.searchTag.blur()
            }else {
                this.showTagAddPopover = false
            }
        },
        defaultCheckeds() {
            this.list.forEach(item => {
                const isHave = this.checkeds[item.photoId]

                item.checked = !!isHave
            })
        },
        setIsDataFull() {
            Object.values(this.checkeds).forEach(item => {
                let {
                    // 审核第一步
                    style,
                    currencyTag,
                    format,
                    formTag,
                    checkSteps,
                    midName,
                    is_recommend_js,
                    // 审核第二三步
                    acceptancePrice,
                    userSplitRate,
                    rewardMoney,
                    dealType,
                } = item

                let isDataFull = true

                if(this.dialogType === 'examine') {
                    // 审核第一步
                    if(+checkSteps === 0) {
                        if(midName === undefined || midName.trim() === '') {
                            isDataFull = false
                        }else if(midName.length > 20) {
                            isDataFull = false
                        }else if(style === undefined) {
                            isDataFull = false
                        }else if(formTag === '' || formTag === undefined || !formTag.length) {
                            isDataFull = false
                        }else if(currencyTag === '' || currencyTag === undefined || !currencyTag.length) {
                            isDataFull = false
                        }else if(format === undefined) {
                            isDataFull = false
                        }
                    // 审核第二三步
                    }else if(+checkSteps === 1 || +checkSteps === 2) {
                        if((acceptancePrice === '' || acceptancePrice === undefined) && +dealType === 1) {
                            isDataFull = false
                        }else if((userSplitRate === '' || userSplitRate === undefined) && +dealType === 2) {
                            isDataFull = false
                        }else if(rewardMoney === '' || rewardMoney === undefined) {
                            isDataFull = false
                        }
                    }
                }else if(this.dialogType === 'reject') {
                    let { reason } = item

                    if(reason === undefined) {
                        isDataFull = false
                    }
                }else if(this.dialogType === 'back') {
                    let { back, remarks } = item

                    if(back === undefined || back === '') {
                        isDataFull = false
                    }else if(remarks === undefined || remarks.trim() === '') {
                        isDataFull = false
                    }
                }
                this.$set(item, 'isDataFull', isDataFull)
            })
        },
        // 回退列表
        backList(checkSteps) {
            let list = this.allBackList

            return list.slice(0, checkSteps || 0)
        },
    },
    created() {
        this.init();
    },
    computed: {
        flexiblePricingTip() {
            return `${this.currentDialogClickCard.oldPriceCheckName}申请修改该项目验收价格或结算方式，是否审批通过？`
        },
        currentIpName() {
            let photoworkIp = this.ipList.find(item => item.ipId === this.examineForm.ip)

            return (photoworkIp && photoworkIp.name) || ''
        },
        classes() {
            return [prefix];
        },
        allBackList() {
            return [
                { key: 0, value: '视觉审核（1/3）' },
                { key: 1, value: '价格确认（2/3）' },
                { key: 2, value: '价格审批（3/3）' },
            ]
        }
    },
    watch: {
        'currentDialogClickCard': {
            handler() {
                window.setTimeout(() => {
                    if(this.$refs.tag) {
                        this.currentDialogClickCard.formTag = this.$refs.tag.getCheckedNodes(true).map(item => item.value)
                    }
                    this.setIsDataFull()
                }, 0)
            },
            immediate: true,
            deep: true
        },
        showExamineDialog(val) {
            if(!val) {
                this.defaultCheckeds()
            }
        },
        list: {
            handler() {
                let checkeds = {...this.checkeds}

                this.list.forEach(item => {
                    if(item.checked) {
                        if(!checkeds[item.photoId]) {
                            checkeds[item.photoId] = item
                        }
                    }else {
                        delete checkeds[item.photoId]
                    }
                })

                this.$emit('input', JSON.parse(JSON.stringify(checkeds)))
            },
            deep: true,
            immediate: true
        },
        data: {
            handler(val) {
                console.log(val,'data')
                const list = JSON.parse(JSON.stringify(val))

                // 初始化默认数据
                list.forEach(item => {
                    item.checked = false
                    item.is_recommend_js = false
                    item.is_check_recommend = false

                    if(+item.checkStatus === 0) {
                        if(+item.checkSteps === 0) {
                            item.midIdName = item.midIdName || ''
                            let fileNamePart = item.midIdName.split('.')

                            fileNamePart.splice(-1)
                            item.midName = fileNamePart.join('')
                            // 审核第一步，素材格式默认勾选
                            if(item.midIdName) {
                                let midIdNameSlice = item.midIdName.split('.')
                                let suffix = midIdNameSlice.splice(-1)[0]

                                if(suffix) {
                                    if(suffix === 'jpg') {
                                        suffix = 'jpeg'
                                    }
                                    item.format = suffix
                                }
                            }
                        }else if(+item.checkSteps === 1) {
                            item.dealType = 1
                            item.acceptancePrice = undefined
                            item.userSplitRate = undefined
                            item.rewardMoney = undefined
                            item.edit = true
                        }else if(+item.checkSteps === 2) {
                            item.edit = false
                        }
                    }
                })

                this.list = list
                this.defaultCheckeds()
            },
            deep: true,
            immediate: true
        },
        value: {
            handler(val) {
                this.checkeds = JSON.parse(JSON.stringify(val))
            },
            deep: true,
            immediate: true
        }
    }
};
</script>

<style lang="scss">
$prefixCls: w-batch-examine;

@mixin imageWrap() {
    .p-image-wrap {
        position: relative;
        align-items: center;
        background-color: #ddd;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;
        .el-image {
            width: 100%;
            height: 100%;
            display: block;
            >img{
                width: auto;
                height: auto;
                max-width: 100%;
                max-height: 100%;
                transform: translate(-50%, -50%);
                position: absolute;
                left: 50%;
                top: 50%;
            }
        }
        .p-check-wrap {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            cursor: pointer;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 48px;
            &.p-card-checked {
                color: #67C23A;
            }
            .p-check-operation {
                position: absolute;
                bottom: 20px;
                left: 50%;
                transform: translateX(-50%);
                display: inline-flex;
                .el-button--mini {
                    padding: 4px 10px;
                }
            }
        }
    }
}

.#{$prefixCls} {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    overflow-x: hidden;
    .p-list {
        padding: 30px 30px 0;
        .p-list-item{
            color: #333;
            padding-bottom: 30px;
            transition: all .3s;
            .p-card {
                transition: all 0.6s;
                border-radius: 5px;
                &:hover {
                    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
                }
                .p-strong {
                    color: #33B3FF;
                }
            }
            @include imageWrap();
            .p-desc-wrap{
                padding: 10px 14px;
                .p-title{
                    font-size: 14px;
                    line-height: 16px;
                    margin: 12px 0;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }

    .w-user-info-wrap{
        display: flex;
        align-items: center;
        padding-top: 10px;
        border-top: 1px solid #F4F6F9;
        .w-avatar{
            width: 24px;
            height: 24px;
            line-height: 0;
            img{
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
        .w-name{
            flex: 1;
            margin-left: 10px;
            font-size: 12px;
            line-height: 18px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .w-time {
            color: #999;
        }
        .w-state {
            font-size: 12px;
        }
    }

    .p-examine-dialog {
        .el-dialog__body {
            display: flex;
        }
        .w-required-tag {
            color: #ff2336;
        }
        .el-dialog__footer {
            position: relative;
            .p-checked-count {
                position: absolute;
                left: 30px;
                top: 20px;
                color: #666;
            }
        }
        .el-form {
            max-height: 500px;
            overflow-y: auto;
            width: 100%;
            .p-cover-btn {
                margin-left: 10px;
            }
            .el-radio-group {
                display: inline-block;
                width: auto;
                .el-radio {
                    margin-right: 0;
                    display: block;
                    width: auto;
                }
            }
        }
        .w-remove-examine {
            text-align: center;
            margin-top: 20px;
        }
        .w-pic-list {
            width: 240px;
            height: 500px;
            overflow-y: auto;
            padding: 0 10px 0 30px;
            @include imageWrap();
            .p-image-wrap {
                border-radius: 5px;
                border: 2px solid #ddd;
                .p-check-wrap {
                    .p-check-operation {
                        bottom: 10px;
                    }
                }
            }
            .w-image-checked {
                border: 2px solid #33B3FF;
            }
            li {
                margin-bottom: 10px;
            }

            .w-data-defect-tag {
                position: absolute;
                width: 8px;
                height: 8px;
                background-color: #ff2336;;
                border-radius: 50%;
                top: 10px;
                right: 10px;
            }

            .w-user-info-wrap {
                border-top: 0;
                position: absolute;
                padding: 0 10px;
                box-sizing: border-box;
                top: 10px;
                width: 100%;
                padding-top: 0;
                height: 30px;
                .w-avatar {
                    margin-left: 14px;
                }
                .w-name {
                    margin-left: 6px;
                }
            }
        }
        .w-form-wrap {
            width: 100%;
        }
        .p-tip {
            color: #999;
            font-size: 12px;
        }
        .p-tag-wrap {
            line-height: normal;
        }
        .el-select,.el-cascader,.el-textarea,.el-input {
            width: 300px;
        }
        .el-input-number {
            width: auto;
        }
        .p-comment {
            width: 320px;
        }
        .w-cover-note-btn {
            position: relative;
            top: -40px;
        }
        .p-tips {
            text-align: center;
            color: #999;
            margin-bottom: 24px;
        }
        .el-cascader__tags {
            max-height: 200px;
            overflow: auto;
        }

        .p-data-wrap {
            padding: 0 20px;
            display: flex;
            .p-data-item {
                flex: 1;
                color: #333;
                .p-label {
                    color: #999;
                    margin-bottom: 16px;
                    display: inline-block;
                }
                .el-form-item {
                    margin-bottom: 0px;
                }
                &.p-data-last-item {
                    flex: 3;
                    border-left: 1px solid #efefef;
                    margin-left: 40px;
                    padding-left: 40px;
                    .el-form-item {
                        margin-bottom: 22px;
                    }
                }
            }
        }

        .p-level-wrap {
            width: 300px;
            display: inline-block;
            .p-level-item {
                display: flex;
                margin-bottom: 10px;
                padding-right: 10px;
                border: 1px solid #efefef;
                width: 300px;
                box-sizing: border-box;
                padding: 6px;
                border-radius: 4px;
                cursor: pointer;
                &-active {
                    border: 1px solid #33B3FF;
                }
                >img {
                    width: 80px;
                    height: 80px;
                    border-radius: 4px;
                }
                .p-level-content {
                    flex: 1;
                    line-height: 24px;
                    margin-left: 6px;
                    h3 {
                        color: #33B3FF;
                    }
                    .p-level-desc {
                        color: #999;
                        font-size: 12px;
                        line-height: 18px;
                    }
                }
            }
        }
    }

    .w-error-dialog {
        .el-form-item__content {
            display: flex;
            align-items: center;
        }
        .w-pic-list {
            height: auto;
        }
    }
}

.w-examine-cover-popover {
    .w-content {
        .w-strong {
            color: #33B3FF;
        }
    }
    .w-btn-wrap {
        margin-top: 10px;
        text-align: center;
    }
}

</style>

<style scoped>
.doc_btn{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 23px;
    color: #333;
    font-size: 14px;
    background: #fff;
    border-radius: 4px;
    margin: 0 10px;
    border:1px solid #999;
}
.doc_btn:hover{
    border:1px solid #33B3FF;
    color:#33B3FF;
    height: 23px;
}
.doc_color{
    border:1px solid #33B3FF;color:#33B3FF
}
</style>
